import Linking from "./Linking";

export default Linking;
